<template>
  <div v-if="trackName">
    <div class="font-size12">{{trackName}}</div>
  </div>
</template>

<script>
  export default {
    props:{
      submission:{
        type:Object,
        value:null
      },
      draftinfo:{
        type:Object,
        value:null
      },
    },
    data () {
      return {
        trackName:'',
      }
    },
    methods:{
      init(){
        let trackName=[]
        if (this.draftinfo.activityAuth.isTrack!=1) return this.trackName=''
        this.draftinfo.trackList.some(track=>{
          if(track.id==this.submission.trackId){
            trackName=[track.name]
            return true
          }
          if(track.childList.length>0){
            track.childList.some(ch=>{
              if(ch.id==this.submission.trackId){
                trackName=[track.name,ch.name]
                return true
              }
            })
          }
        })
        //console.error(trackName)
        return this.trackName=trackName.join('-')
      },
    },
    watch:{
      submission(){
        this.init()
      },
    },
    mounted(){
      this.init()
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/card/track.vue